import { memo } from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { Tag } from 'lucide-react';

function IssueCouponNode({ data, selected }: NodeProps) {
  const config = (data.config as Record<string, unknown>) ?? {};
  const couponType = (config.couponType as string) ?? '';
  const valueObj = (config.value as { amount?: number; unit?: string }) ?? {};
  const amount = valueObj.amount ?? 0;
  const unit = valueObj.unit ?? '';

  const summary =
    couponType && amount
      ? `${couponType} — ${amount}${unit === 'percent' ? '%' : unit === 'fixed' ? ' off' : ''}`
      : null;

  return (
    <div
      className={`w-52 rounded-xl bg-white shadow-sm border border-zinc-200 border-l-4 border-l-orange-500 ${
        selected ? 'ring-2 ring-emerald-400' : ''
      }`}
    >
      <Handle type="target" position={Position.Top} className="!bg-orange-500" />
      <div className="flex items-center gap-2 px-3 py-2 border-b border-zinc-100">
        <Tag size={14} className="text-orange-500 shrink-0" />
        <span className="text-xs font-semibold text-zinc-700 uppercase tracking-wide">
          Issue Coupon
        </span>
      </div>
      <div className="px-3 py-2">
        <p className="text-xs text-zinc-800 font-medium truncate">
          {summary || <span className="italic text-zinc-400">Not configured</span>}
        </p>
      </div>
      <Handle type="source" position={Position.Bottom} className="!bg-orange-500" />
    </div>
  );
}

export default memo(IssueCouponNode);
